"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");

var MeetingSessionTURNCredentials_1 = require("../meetingsession/MeetingSessionTURNCredentials");

var DefaultModality_1 = require("../modality/DefaultModality");

var Versioning_1 = require("../versioning/Versioning");

var BaseTask_1 = require("./BaseTask");
/*
 * [[ReceiveTURNCredentialsTask]] asynchronously retrieves TURN credentials.
 */


var ReceiveTURNCredentialsTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(ReceiveTURNCredentialsTask, _BaseTask_1$default);

  var _super = _createSuper(ReceiveTURNCredentialsTask);

  function ReceiveTURNCredentialsTask(context) {
    var _this;

    _classCallCheck(this, ReceiveTURNCredentialsTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'ReceiveTURNCredentialsTask';
    _this.url = context.meetingSessionConfiguration.urls.turnControlURL;
    _this.meetingId = context.meetingSessionConfiguration.meetingId;
    _this.joinToken = context.meetingSessionConfiguration.credentials.joinToken;
    return _this;
  }

  _createClass(ReceiveTURNCredentialsTask, [{
    key: "cancel",
    value: function cancel() {
      // Just in case. The baseCancel behavior should prevent this.

      /* istanbul ignore else */
      if (this.cancelPromise) {
        var error = new Error("canceling ".concat(this.name()));
        this.cancelPromise(error);
        delete this.cancelPromise;
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var options, responseBodyJson;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.context.turnCredentials) {
                  _context2.next = 3;
                  break;
                }

                this.context.logger.info('TURN credentials available, skipping credentials fetch');
                return _context2.abrupt("return");

              case 3:
                this.context.logger.error('missing TURN credentials - falling back to fetch');

                if (this.url) {
                  _context2.next = 7;
                  break;
                }

                this.context.logger.info('TURN control url not supplied, skipping credentials fetch');
                return _context2.abrupt("return");

              case 7:
                options = {
                  method: 'POST',
                  mode: 'cors',
                  cache: 'no-cache',
                  credentials: 'omit',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Chime-Auth-Token': '_aws_wt_session=' + new DefaultModality_1.default(this.joinToken).base()
                  },
                  redirect: 'follow',
                  referrer: 'no-referrer',
                  body: JSON.stringify({
                    meetingId: this.meetingId
                  })
                };
                this.context.logger.info("requesting TURN credentials from ".concat(this.url)); // eslint-disable-next-line @typescript-eslint/no-explicit-any

                _context2.next = 11;
                return new Promise(function (resolve, reject) {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var responseBody;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            this.cancelPromise = function (error) {
                              reject(error);
                            };

                            _context.prev = 1;
                            _context.next = 4;
                            return fetch(Versioning_1.default.urlWithVersion(this.url), options);

                          case 4:
                            responseBody = _context.sent;
                            this.context.logger.info("received TURN credentials");

                            if (!(responseBody.status && responseBody.status === 403)) {
                              _context.next = 9;
                              break;
                            }

                            reject(new Error("canceling ".concat(this.name(), " due to the meeting status code: ").concat(MeetingSessionStatusCode_1.default.TURNCredentialsForbidden)));
                            return _context.abrupt("return");

                          case 9:
                            if (!(responseBody.status && responseBody.status === 404)) {
                              _context.next = 12;
                              break;
                            }

                            reject(new Error("canceling ".concat(this.name(), " due to the meeting status code: ").concat(MeetingSessionStatusCode_1.default.MeetingEnded)));
                            return _context.abrupt("return");

                          case 12:
                            _context.t0 = resolve;
                            _context.next = 15;
                            return responseBody.json();

                          case 15:
                            _context.t1 = _context.sent;
                            (0, _context.t0)(_context.t1);
                            _context.next = 22;
                            break;

                          case 19:
                            _context.prev = 19;
                            _context.t2 = _context["catch"](1);
                            reject(_context.t2);

                          case 22:
                            _context.prev = 22;
                            delete this.cancelPromise;
                            return _context.finish(22);

                          case 25:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this, [[1, 19, 22, 25]]);
                  }));
                });

              case 11:
                responseBodyJson = _context2.sent;
                this.context.turnCredentials = new MeetingSessionTURNCredentials_1.default();
                this.context.turnCredentials.password = responseBodyJson.password;
                this.context.turnCredentials.ttl = responseBodyJson.ttl;
                this.context.turnCredentials.uris = responseBodyJson.uris.map(function (uri) {
                  return _this2.context.meetingSessionConfiguration.urls.urlRewriter(uri);
                }).filter(function (uri) {
                  return !!uri;
                });
                this.context.turnCredentials.username = responseBodyJson.username;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return ReceiveTURNCredentialsTask;
}(BaseTask_1.default);

exports.default = ReceiveTURNCredentialsTask;